import { useState } from "react";
import { Modal } from "react-bootstrap";
import { useEffect } from "react";
import AlertBox from "../AlertBox";
import { deleteIncidentById } from "../../api/infrastructure";
import { useIncidentHook } from "../../utils/infrastructure/ProjectPerformanceUtil";
import moment from "moment";

export default function ModalDeleteIncident({ show, id, report_id, onClose, onSuccess }) {
  const { data, loading: dataLoading, error } = useIncidentHook({ id, report_id });
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });

  useEffect(() => {
    if (error) {
      setAlert({ show: true, message: error, type: "danger" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  const handleClose = () => {
    setAlert({ show: false, message: "", type: "" });
    onClose(false);
  };

  const deleteIncindent = async (form) => {
    setLoading(true);
    try {
      let response = await deleteIncidentById(id, report_id, { ...form });
      onSuccess(true, response.data.message, response.data.data);
      handleClose();
    } catch (error) {
      let message = "";
      if (error.response) {
        let { data } = error.response;
        message = data.message;
      } else {
        message = "Something Error Happened";
      }

      setAlert({ show: true, message, type: "danger" });
    }

    setLoading(false);
  };

  return (
    <Modal size="md" show={show} onHide={() => handleClose()}>
      <Modal.Header closeButton>
        <Modal.Title>Hapus Data Insiden</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AlertBox {...alert} />
        <h5 className="text-gray-800">Apakah anda yakin akan menghapus data Insiden ini</h5>
        <table className="table table-striped table-bordered table-hover">
          <tbody>
            <tr>
              <td>Date</td>
              <td className="text-nowrap">{data.date}</td>
            </tr>
            <tr>
              <td>Down</td>
              <td>{data.down && moment.unix(data.down).format("DD MMM YYYY HH:mm:ss")}</td>
            </tr>
            <tr>
              <td>Up</td>
              <td className="text-nowrap">
                {data.up && moment.unix(data.up).format("DD MMM YYYY HH:mm:ss")}
              </td>
            </tr>
            <tr>
              <td>Duration</td>
              <td className="text-nowrap">{data.duration}</td>
            </tr>
            <tr>
              <td>Description</td>
              <td>{data.description}</td>
            </tr>
          </tbody>
        </table>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-default" onClick={() => handleClose()}>
          Tidak
        </button>
        <button
          className="btn btn-danger"
          onClick={() => deleteIncindent()}
          disabled={loading || dataLoading}
        >
          {loading ? "Menunggu ..." : "Ya"}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
